/** @jsxImportSource @emotion/react */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getQuestionsWithFilter } from '../../data';
import { filteringQuestionsAction, filteredQuestionsAction, AppState } from '../../Store';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import PlusIcon from '../../icons/Plus';
import { Title } from '../../components/Title';
import { QuestionListTable } from '../../components/dashboard/QuestionListTable';
import { accountService, UserRole } from '../../account.service';
import { Navigate } from 'react-router-dom';

export const AdmQuestionList = () => {
    const navigate = useNavigate();
    const account = accountService.getAccount();
    const dispatch = useDispatch();
    const questions = useSelector((state: AppState) => state.questions.filtered);

    useEffect(() => {
        const doGetQuestions = async () => {
            dispatch(filteringQuestionsAction());
            const questions = await getQuestionsWithFilter({ search: '' });
            dispatch(filteredQuestionsAction(questions));
        };
        doGetQuestions();
    }, []);

    const handleAdd = () => {
        navigate('/kb/questions/new');
    };

    return (
        <>
            {(!account || account.role !== UserRole.Admin) && <Navigate to="/account/login" />}
            <Title title="Articles" />
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 8,
                }}
            >
                <Container maxWidth={false}>
                    <Grid container justifyContent="space-between" spacing={3}>
                        <Grid item>
                            <Typography color="textPrimary" variant="h5">
                                Article List
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Box sx={{ m: -1 }}>
                                <Button
                                    color="primary"
                                    startIcon={<PlusIcon fontSize="small" />}
                                    sx={{ m: 1 }}
                                    variant="contained"
                                    onClick={handleAdd}
                                >
                                    Add Article
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box sx={{ mt: 3 }}>
                        <QuestionListTable questions={questions} />
                    </Box>
                </Container>
            </Box>
        </>
    );
};
